import React from 'react';
import { Box, Heading, LayoutProps, Link, Text } from '@chakra-ui/react';
import { MdArrowForward } from 'react-icons/md';

export interface CardProps {
  title: string;
  body: string | React.ReactNode;
  href?: string;
  containerMinHeight?: LayoutProps['minH'];
  bodyMinHeight?: LayoutProps['minH'];
  learnMoreDescription?: string | React.ReactNode;
  hideLearnMore?: boolean;
}

const Card = ({
  title,
  body,
  href = undefined,
  containerMinHeight = undefined,
  bodyMinHeight = undefined,
  hideLearnMore = false,
  learnMoreDescription = undefined,
}: CardProps) => {
  const hoverProps = href
    ? {
        boxShadow: '0 2px 10px rgb(0 0 0 / 11%)',
        borderTop: '8px solid #7CB1EA',
      }
    : undefined;

  const cardComponent = (
    <Box
      maxW={['100%', '100%', '350px']}
      minH={containerMinHeight}
      padding="10"
      borderRadius="10px"
      backgroundColor="#F9FCFF"
      boxShadow="0px 45px 66px 2px rgba(118, 118, 118, 0.2)"
      _hover={hoverProps}
    >
      <Box minH={bodyMinHeight}>
        <Heading
          mb="10"
          fontWeight="bold"
          lineHeight={['150%', '120%']}
          fontSize={['3xl', '2xl', '3xl', '3xl']}
          minH="20"
        >
          {title}
        </Heading>
        <Text as="p" fontSize="18">
          {body}
        </Text>
      </Box>
      <Box
        mt="10"
        mb="7"
        background="#7CB1EA"
        borderRadius="5px"
        height="8px"
        width="100%"
      />
      {!hideLearnMore && (
        <>
          {learnMoreDescription && <Box py="3">{learnMoreDescription}</Box>}
          <Text as="span" fontWeight="bold">
            Learn more <MdArrowForward style={{ display: 'inline-block' }} />
          </Text>
        </>
      )}
    </Box>
  );

  return href ? (
    <Link href={href} color="inherit" _hover={{ textDecoration: 'inherit' }}>
      {cardComponent}
    </Link>
  ) : (
    cardComponent
  );
};

Card.defaultProps = {
  hideLearnMore: false,
  containerMinHeight: undefined,
  bodyMinHeight: undefined,
  learnMoreDescription: undefined,
};

export default Card;
